import uuid from 'uuid';
import {WEBSOCKET_SEND, WebsocketAction} from '../models/Websockets';
import {WebUsersCursor, WebUsersFilter} from '../models/WebUser';

export enum UsersActionType {
    IS_LOADING_USERS = 'IS_LOADING_USERS',
    SET_USERS_FILTER = 'SET_USERS_FILTER',
    RESET_USERS = 'RESET_USERS',
}

/**
 * Request one page of users. The backend answers with WEB_USERS_RESULT carrying `hasMore` and
 * `nextCursor`; the reducer appends the rows and this action is dispatched again until the list is
 * complete, so the table fills progressively instead of waiting for the whole set.
 *
 * `stateId` is regenerated whenever the filter changes and echoed back by the backend, which lets
 * the reducer drop responses belonging to a filter the user has already replaced.
 */
export const loadWebUsers = (cursor: WebUsersCursor | null = null) => (dispatch: any, getState: any) => {
  const {filter, stateId} = getState().users;

  dispatch({type: UsersActionType.IS_LOADING_USERS, isLoading: true});

  dispatch({
    type: WEBSOCKET_SEND,
    payload: {
      action: WebsocketAction.GET_WEB_USERS,
      message: {
        ...filter,
        cursor,
        stateId,
      },
    },
  });
};

/** Replace the filter and reload from the first page under a fresh stateId. */
export const applyWebUsersFilter = (filter: WebUsersFilter) => (dispatch: any) => {
  dispatch({type: UsersActionType.SET_USERS_FILTER, filter, stateId: uuid.v4()});
  dispatch(loadWebUsers(null));
};

export const resetWebUsers = () => (dispatch: any) => {
  dispatch({type: UsersActionType.RESET_USERS, stateId: uuid.v4()});
};
